import { Axios as AxiosObservable } from 'axios-observable';
export class EsgApi {
    constructor(hrefResolver) {
        this.hrefResolver = hrefResolver;
        this.esgApiUrl = this.hrefResolver.getResolvedUrl('compareEsgApi');
    }
    getData(portfolioId) {
        return AxiosObservable.get(`${this.esgApiUrl}?portfolioIds=${portfolioId}`); // Supplying only one id, no use case for add more
    }
}
